import { ready } from '~/core';

ready('contentGrid', '.contentGrid-more', btn => {
	const grid = btn.closest('.contentGrid')
	const item = btn.closest('.contentGrid-item')
	const back = item.querySelector('.contentGrid-back')
	const others = [...grid.querySelectorAll('.contentGrid-item')].filter(i => i !== item);
	btn.addEventListener('click', () => {
		others.forEach(o => o.classList.remove('is-active'))
		item.classList.add('is-active');
	});
	back.addEventListener('click', () => {
		item.classList.remove('is-active')
	})
});
